import React, { useEffect, useState } from "react"
import { useLang } from "~/hooks/useLang";
import { Autocomplete, FormControl, TextField } from "@mui/material";
import { getOnMissionReason } from "./services";
import type { OnMissionResponse } from "./types";


interface FilterAutocompleteMotiveOnMissionProps {
  readonly motiveOnMissionId: number | null;
  readonly onMotiveOnMissionIdChange: (value: number | null) => void;
  readonly label: string;
  readonly disabled?: boolean;
}

export default function FilterAutocompleteMotiveOnMission({motiveOnMissionId , label, disabled, onMotiveOnMissionIdChange }: FilterAutocompleteMotiveOnMissionProps) {
  const { translate } = useLang()
  const [options, setOptions] = useState<readonly OnMissionResponse[]>([])
  const [value, setValue] = useState<OnMissionResponse | null>(null)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    setLoading(true)
    getOnMissionReason().then((motives) => {
      setOptions(motives)
      setValue(null)
    })
      .finally(() => {
        setLoading(false)
      })
  }, [])

  useEffect(() => {
    if (!motiveOnMissionId) {
      setValue(null)
    } else {
      setValue(options.find(item => item.id == motiveOnMissionId) ?? null)
    }
  }, [motiveOnMissionId, options])

  return (
    <FormControl fullWidth size="small">
      <Autocomplete
        id="filter-devices"
        options={options}
        disabled={disabled}
        value={value}
        noOptionsText={translate('No options')}
        clearText={translate('Clear')}
        size="small"
        loading={loading}
        isOptionEqualToValue={(option, value) => option.id === value.id}
        getOptionLabel={(option) => option.name ?? ''}
        onChange={(_, motive) => {
          setValue(motive)
          onMotiveOnMissionIdChange(motive?.id ?? null)
        }}
        renderInput={(params) => (
          <TextField {...params} label={translate(label ? label : 'Motive')} />
        )}
      />
    </FormControl>
  )
}